/* Lusome quiz result page. Generated by
   landing-pages/builds/2026-09-03-lusome-quiz-funnel-redesign/
   shopify-result-template/assemble-the-result-theme-files.py
   Never hand edit this file: edit results/results-template.html and rebuild. */
/* ============ Verified product data. Poured in by build-the-result-pages.py from the
   stage-2 template that was checked against lusome.com. Never typed here. ============ */
var STORE="", CODE="QUIZGIFT", MASK={id:44358375243950,price:48.00};
var HEX={White:"#F4F1EA","Smoked Pearl":"#B6BABF",Champagne:"#E6D7BA",Platinum:"#CDD0D4",Black:"#1C1C1C",Caramel:"#B07D4F",Silver:"#C6C7C9","Denim Mix":"#3F5A70",Marlin:"#31495A","Dark Sapphire":"#22314A",Ruby:"#8E2B3A","Light Shadow":"#CFC9BD"};
var SHEETS={img:"https://cdn.shopify.com/s/files/1/0609/8914/5262/files/01.png?v=1760491670",variants:{
  "Queen":[["White",43527880638638,328],["Champagne",45384164802734,328],["Platinum",46921025585326,398]],
  "King":[["White",43527880671406,358],["Smoked Pearl",44395612897454,358],["Champagne",45384164835502,358]],
  "Split King":[["White",45384164868270,398],["Platinum",46921025650862,398]],
  "California King":[["White",46921025683630,358],["Champagne",46921025749166,358],["Platinum",46921025781934,358]]
}};
var AP={
  eva:{name:"Eva Sleepshirt",price:88,meta:"A sleepshirt in the moisture-moving fabric, on you.",img:"https://cdn.shopify.com/s/files/1/0609/8914/5262/files/13_3e4ddc5b-4f11-43eb-9526-6f4c6c04fa47.png?v=1760535997",v:{
    XS:[["Black",42325558198446],["Denim Mix",44193679933614],["Marlin",42325558034606]],
    S:[["Black",42325558231214],["Caramel",45877269233838],["Silver",47830262775982],["Denim Mix",44193679999150],["Ruby",47980518015150]],
    M:[["Caramel",45877269266606],["Silver",47830262808750]],
    L:[["Caramel",45877269299374],["Silver",47830262841518]],
    XL:[["Caramel",45877269332142],["Silver",47830262874286]]}},
  ginger:{name:"Ginger Cami",price:78,meta:"A breezy tank cut for hot sleepers.",img:"https://cdn.shopify.com/s/files/1/0609/8914/5262/files/1_1d9a79d4-7c02-4241-b15c-10fce97279a6.png?v=1760471653",v:{
    S:[["Caramel",46393270239406],["Silver",47829704540334],["Black",47829704573102]],
    M:[["Caramel",46393270304942],["Silver",47829704605870],["Black",47829704638638]],
    L:[["Caramel",46393270370478],["Silver",47829704671406],["Black",47829704704174]],
    XL:[["Caramel",46393270436014],["Silver",47829704736942],["Black",47829704769710]]}},
  cara:{name:"Cara Short",price:78,meta:"The matching short, nothing clingy.",img:"https://cdn.shopify.com/s/files/1/0609/8914/5262/files/5_b7c5c571-0c68-406c-9462-0d1061097a64.png?v=1760536106",v:{
    XS:[["Caramel",46393372213422],["Light Shadow",42325563244718],["Dark Sapphire",46393372180654]],
    S:[["Denim Mix",42325563441326],["Caramel",46393372278958],["Light Shadow",42325563277486],["Dark Sapphire",46393372246190],["Silver",47829716238510],["Black",47829716271278]],
    M:[["Caramel",46393372344494],["Light Shadow",42325563310254],["Silver",47829716304046],["Black",47829716336814]],
    L:[["Caramel",46393372410030],["Light Shadow",42325563343022],["Dark Sapphire",46393372377262],["Silver",47829716369582],["Black",47829716402350]],
    XL:[["Caramel",46393372475566],["Dark Sapphire",46393372442798],["Silver",47829716435118],["Black",47829716467886]]}},
  donnashirt:{name:"Donna Long-Sleeve Shirt",price:98,meta:"Full-coverage long sleeve that still breathes.",img:"https://cdn.shopify.com/s/files/1/0609/8914/5262/files/1_e78f93d1-1450-44f9-bd9b-44db07f52579.png?v=1760536138",v:{
    XS:[["Denim Mix",42325560033454]],
    S:[["Denim Mix",42325560066222],["Caramel",46194594250926],["Dark Sapphire",46872991203502]],
    M:[["Denim Mix",42325560098990],["Caramel",46194594283694],["Dark Sapphire",46872991236270]],
    L:[["Denim Mix",42325560131758],["Caramel",46194594316462],["Dark Sapphire",46872991269038]],
    XL:[["Denim Mix",42325560164526],["Caramel",46194594349230]]}},
  donnapant:{name:"Donna Pant",price:98,meta:"The matching long pant.",img:"https://cdn.shopify.com/s/files/1/0609/8914/5262/files/1_26f9fc4f-cb55-409b-b49c-b4b1a0c66eac.png?v=1760487834",v:{
    XS:[["Denim Mix",42325561737390]],
    S:[["Denim Mix",42325561770158],["Caramel",46030636613806]],
    M:[["Denim Mix",42325561802926],["Caramel",46030636646574]],
    L:[["Denim Mix",42325561835694],["Caramel",46030636679342]],
    XL:[["Denim Mix",42325561868462],["Caramel",46030636712110]]}}
};
var STYLES={mid:["eva"],minimal:["ginger","cara"],full:["donnashirt","donnapant"],depends:["eva"]};

/* The photographs show Smoked Pearl as a deep charcoal. The lifted swatch was light grey. */
HEX["Smoked Pearl"]="#4F5357";

/* ============ Which result this page is. The builder locks it. ============ */
/* ============ What the Shopify page tells this script ============
   window.LQR is written by sections/lp-quiz-result.liquid: which result this page
   is, the discount code from the theme editor, and every variant's live price
   and stock. The verified numbers above stand wherever Liquid found nothing. */
var LQR = (typeof window !== "undefined" && window.LQR) || {};
var CURRENCY = LQR.currency || "CAD";
if (LQR.code) { CODE = LQR.code; }
if (typeof LQR.store === "string") { STORE = LQR.store; }
(function overlayLivePrices(){
  var rows = LQR.prices;
  if (!LQR.livePrices || !rows || !rows.length) return;
  var live = {};
  rows.forEach(function(r){ live[r[0]] = { price: r[1], available: !!r[2] }; });
  Object.keys(SHEETS.variants).forEach(function(size){
    SHEETS.variants[size].forEach(function(row){
      var f = live[row[1]];
      if (f && f.price > 0) row[2] = f.price;
    });
  });
  Object.keys(AP).forEach(function(key){
    var p = AP[key], found = null;
    Object.keys(p.v).forEach(function(size){
      p.v[size].forEach(function(row){
        var f = live[row[1]];
        if (found === null && f && f.price > 0) found = f.price;
      });
    });
    if (found !== null) p.price = found;
  });
  var m = live[MASK.id];
  if (m && m.price > 0) MASK.price = m.price;
})();

/* ============ Which result this page is ============
   Liquid decides first, from the theme editor setting or the page address.
   If it decided nothing, read the address here too, so the page still locks
   to the right result even if the template is used on a page Liquid did not
   recognise. Last of all ?result=, then furnace. */
var LOCKED_RESULT = LQR.result || null;
if (!LOCKED_RESULT) {
  var lqrPath = (typeof location !== "undefined" ? location.pathname : "").toLowerCase();
  var lqrRules = [["3am-soak", "soak"], ["broken-thermostat", "thermostat"], ["human-furnace", "furnace"]];
  for (var lqrI = 0; lqrI < lqrRules.length; lqrI++) {
    if (lqrPath.indexOf(lqrRules[lqrI][0]) > -1) { LOCKED_RESULT = lqrRules[lqrI][1]; break; }
  }
}

/* ============ Line icons, one stroke weight ============ */
function ico(d){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'+d+'</svg>'; }
var I={
  check:'<path d="M5 12l4 4L19 6"/>',
  drop:'<path d="M12 3c3 4 6 7 6 10.5a6 6 0 0 1-12 0C6 10 9 7 12 3z"/>',
  clock:'<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  fan:'<circle cx="12" cy="12" r="2"/><path d="M12 10c0-4 2-6 4-6s2 4-4 6M14 12c4 0 6 2 6 4s-4 2-6-4M12 14c0 4-2 6-4 6s-2-4 4-6M10 12c-4 0-6-2-6-4s4-2 6 4"/>',
  heart:'<path d="M12 21s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 11c0 5.5-7 10-7 10z"/>',
  flat:'<rect x="3" y="6" width="18" height="12" rx="1.5"/><path d="M3 10h18"/>',
  fitted:'<path d="M3 20V9a6 6 0 0 1 6-6h12"/><path d="M3 14h4a4 4 0 0 0 4-4V3"/><path d="M3 20h9"/>',
  pillow:'<path d="M4 8c4-1.2 12-1.2 16 0v8c-4 1.2-12 1.2-16 0z"/><path d="M4 8L3 5M20 8l1-3M4 16l-1 3M20 16l1 3"/>'
};

/* ============ The sheets, from lusome.com (product page, 03/09/2026) ============ */
var CDN="https://cdn.shopify.com/s/files/1/0609/8914/5262/files/";
var MASK_IMG="https://cdn.shopify.com/s/files/1/0609/8914/5262/files/3_6f49a729-31d9-45a6-8dc1-49237d76efe6.png?v=1760978190&width=300";
var SHEET_PHOTOS={
  "Smoked Pearl":["01.png","02.png","03.png","4_34dd75a6-f226-42d1-b49c-7f048ce4cda3.png"],
  "White":["5_edff6023-2141-4b92-8628-501612be7c5c.png","6_043291e7-ffcd-46e5-aae1-38882a92aa3e.png","7_b74a6c46-2de5-43ae-88ef-e2a7fdcc20c1.png","8_094c2449-edcf-4e1c-ba9a-e1f0546ffc50.png"],
  "Champagne":["9_6766dd2d-d47c-4405-8a4e-a05599a64221.png","10_e3fc292c-1d1b-4b8f-a42f-b037e9003104.png","11_3aadcfa5-0b3f-4748-84d6-3030cc87d5af.png","12_2c2036d1-690e-408a-a5a1-1328fb963699.png"],
  "Platinum":["13_2895787a-c5db-439b-96f2-3cb0ed1ca76b.png","14_49f6445b-b021-414b-88e4-82aae947d273.png","15_d15c16cc-83e2-48f2-ac29-ca9463d03f8b.png","16_35bebdfd-f94d-4ed6-93a7-b405a300104f.png"]
};
var PHOTO_CAPS=["On the bed","The set, folded","The fitted corner","In the room"];
function sheetPhoto(color,i,w){ var set=SHEET_PHOTOS[color]||SHEET_PHOTOS.White; return CDN+set[i]+"?width="+(w||900); }
/* Every dimension is from Lusome's own size guide. */
var DIMS={
  "Queen":          {flat:'92" x 104"',  fitted:'60" x 80" x 16"', fittedN:1, pillow:'20" x 31"', pillowName:"Queen"},
  "King":           {flat:'110" x 106"', fitted:'76" x 80" x 16"', fittedN:1, pillow:'20" x 40"', pillowName:"King"},
  "Split King":     {flat:'110" x 106"', fitted:'39" x 80" x 16"', fittedN:2, pillow:'20" x 40"', pillowName:"King"},
  "California King":{flat:'110" x 106"', fitted:'72" x 84" x 16"', fittedN:1, pillow:'20" x 40"', pillowName:"King"}
};
var SHEET_REVIEWS=[
  ["Hesitant at first given the cost. Once on our bed they are never coming off. Well worth the investment.","Katrina B."],
  ["Pricier than standard sheets, worth every penny. The fitted sheet stays in place, and after several washes they still look and feel great.","Allison"],
  ["I have tried bamboo, tencel and many other cooling sheets. Blown away. I already ordered another set for our cottage.","Sheila C."],
  ["They fit our Tempur-Pedic split king. Over a week and not once untucked, just getting softer.","Robert S."]
];
var SHEET_FAQ=[
  ["How do Lusomé sheets stop night sweats?","Xirotex™ Cool absorbs heat before your body starts to sweat, regulating temperature by up to 5°C. You sleep dry instead of waking up drenched."],
  ["Are Lusomé sheets proven to work?","Yes. In an Ivy-League medical school study, 69% reported better sleep, 42% had fewer night sweats, 33% were completely night-sweat free, and sleep increased by 26 minutes a night."],
  ["What makes them different from other “cooling” sheets?","Most “cooling” fabrics wick sweat once it is already there. Lusomé absorbs the heat before sweating starts."],
  ["Only for women in menopause?","No. Anyone who overheats, sleeps restlessly or shares a bed with a hot sleeper benefits."],
  ["Will they fit my mattress?","Your size is set from your quiz answer. A 16 inch pocket, all-around elastic and corner bands, labelled long and short. The size guide above has every dimension."],
  ["Comfortable year-round?","Yes. The sheets absorb and release heat as your temperature changes: cool in summer, cozy in winter."],
  ["How do I care for them?","Machine wash cold, tumble dry low. No bleach, no fabric softener (it blocks the technology)."]
];

/* ============ Copy per result ============ */
var CONFIG={
  soak:{
    rname:"3am Soak Set",
    one:"Sheets and sleepwear that move the sweat off your skin, so you stop waking up wet.",
    offer:'<b>[NAME]</b> free sleep mask + $50 gift card with your sheets',
    whySheets:"The wet fabric is what wakes you. These absorb the heat before the sweat comes, and move what does come off your skin.",
    revH:'"I went from soaked to a peaceful sleep."',
    reviews:[
      "I take medication that gave me night sweats so bad I had salt stains on my sheets. These have stopped all of the excessive sweating. Life changing.",
      "I used to wake up three times a night to change my pajamas. It was like I had showered in them. I went from sweating buckets to a peaceful sleep.",
      "For the first time in years, dry, dry, dry. Thank you."
    ],
    faq:[
      ["Will these actually keep me dry?","They do not try to make you cold. The fabric absorbs heat before you sweat and moves any moisture off your skin. In the published study, most participants reported fewer or no night sweats, and the group slept about 26 minutes longer a night."],
      ["What size sleepwear should I order?","It runs snug, so size up. Tops run a little smaller than bottoms. Between sizes, take the larger. Easy exchange within 30 days."],
      ["Is the free mask and the $50 gift card a real quiz offer?","Yes. Both come with the sheets ordered from this page. The mask is added free at checkout with code [CODE], and the $50 gift card is emailed after your order."],
      ["Can I buy just the sleepwear?","Yes, at full price. The mask and gift card stay with the sheets."],
      ["What if it does not work for me?","30 days. If you are not drier, send it back for a refund or store credit."]
    ],
    finalH:"Wake up dry. Starting this week."
  },
  thermostat:{
    rname:"Broken Thermostat Set",
    one:"Built to hold you level through the hot, then cold, then hot again.",
    offer:'<b>[NAME]</b> free sleep mask + $50 gift card with your sheets',
    whySheets:"Cool, then soaked, then cold. These absorb the heat as it builds and move the sweat off you, which stops the swing.",
    revH:'"It finally regulates my temperature."',
    reviews:[
      "I have an issue of regulating my temperature while I sleep. Now I am not waking up to either kick off the covers or find my covers again.",
      "It keeps me dry and warm once the hot flash has passed. I can keep a fan on without fearing that I will freeze after I sweat.",
      "Helped me through night time power surges by drying so quickly."
    ],
    faq:[
      ["I run cold, then hot, then cold again. How does this help?","The swing is the wet fabric, not just the heat. The sheets absorb heat as you warm and move sweat off your skin, so you never lie in a cold, damp top waiting to warm up."],
      ["What size sleepwear should I order?","It runs snug, so size up. Tops run a little smaller than bottoms. Between sizes, take the larger. Easy exchange within 30 days."],
      ["Is the free mask and the $50 gift card a real quiz offer?","Yes. Both come with the sheets ordered from this page. The mask is added free at checkout with code [CODE], and the $50 gift card is emailed after your order."],
      ["Can I buy just the sleepwear?","Yes, at full price. The mask and gift card stay with the sheets."],
      ["What if it does not work for me?","30 days. If you are not steadier and drier, send it back for a refund or store credit."]
    ],
    finalH:"Stop riding the wave. Starting this week."
  },
  furnace:{
    rname:"Human Furnace Set",
    one:"For the sleeper who has always run hot. Dry and level, without freezing out anyone else.",
    offer:'<b>[NAME]</b> free sleep mask + $50 gift card with your sheets',
    whySheets:"You run warm, or the person beside you does. These absorb heat from the hot sleeper and stay neutral for the other.",
    revH:'"Cooler and dry, all night long."',
    reviews:[
      "I have been a hot sleeper for as long as I can remember. These keep me cool and comfortable all night long, even when I usually run hot.",
      "My wife says she is a hot sleeper and was always complaining about sweating at night. She loves these. The cooling is real.",
      "Honestly, for anyone who runs hot at night, this is the best sleep I have had in years."
    ],
    faq:[
      ["I just run hot, I am not in menopause. Still for me?","Yes. The fabric does not care why you run warm. It absorbs the heat and moves moisture off your skin."],
      ["My partner runs hot and I do not. Will this freeze me out?","No. It is not a cold sheet. It cools the hot sleeper and stays neutral for the other, which is why couples buy it."],
      ["What size sleepwear should I order?","It runs snug, so size up. Tops run a little smaller than bottoms. Between sizes, take the larger. Easy exchange within 30 days."],
      ["Is the free mask and the $50 gift card a real quiz offer?","Yes. Both come with the sheets ordered from this page. The mask is added free at checkout with code [CODE], and the $50 gift card is emailed after your order."],
      ["Can I buy just the sleepwear?","Yes, at full price. The mask and gift card stay with the sheets."],
      ["What if it does not work for me?","30 days. If you are not cooler and drier, send it back for a refund or store credit."]
    ],
    finalH:"Sleep cool and dry. Starting this week."
  }
};

/* The sleepwear, per quiz answer */
var WEAR={
  mid:     {name:"Eva Sleepshirt",            keys:["eva"],                  why:"One easy piece in the same moisture-moving knit, so what touches your skin is working too.",
            ticks:["Moved 10x more moisture than the other brands, University of Alberta test","One piece, nothing to kick off at 3am","Feels like a favourite tee"]},
  depends: {name:"Eva Sleepshirt",            keys:["eva"],                  why:"Hot nights and mild ones: one piece in the moisture-moving knit that works on both.",
            ticks:["Moved 10x more moisture than the other brands, University of Alberta test","One piece for hot nights and mild ones","Feels like a favourite tee"]},
  minimal: {name:"Ginger Cami + Cara Short",  keys:["ginger","cara"],        why:"As little on as possible. The lightest pieces we make, in the moisture-moving knit.",
            ticks:["Moved 10x more moisture than the other brands, University of Alberta test","A tank and a short that do not cling","Soft, not technical"]},
  full:    {name:"Donna Shirt + Donna Pant",  keys:["donnashirt","donnapant"],why:"Full coverage in the moisture-moving knit, so covered does not mean clammy.",
            ticks:["Moved 10x more moisture than the other brands, University of Alberta test","Full coverage that still breathes","Soft, not technical"]}
};

/* What her answers mean, one line each. */
var SAID={
  q1:{_i:"drop",
      drenched:["Wake up drenched","The wet fabric wakes you. The set keeps it off you."],
      toohot:["Too hot under the covers","Trapped heat. These sheets absorb it."],
      swings:["Hot, cold, hot again","Sweat overcools you. Move it off and the swing stops."],
      partner:["Partner runs hot","Not a cold sheet. Cools the hot one, neutral for you."],
      cooler:["Want to sleep cooler","Dry is what cool feels like at 3am."]},
  q2:{_i:"clock",
      getin:["Hottest getting into bed","Cool to the touch. The heat goes into the fibre."],
      "3am":["Heat hits around 3am","The night-sweat window. Heat absorbed before it wakes you."],
      allnight:["Hot on and off all night","Level, not cold. Nothing to kick off."],
      summer:["Summer or a warm room","Room heat plus fabric heat. We remove one."]},
  q4:{_i:"fan",
      fan:["Fan did not fix it","Fans cool the room, not the wet fabric on you."],
      ac:["AC did not fix it","Cold air on damp fabric is the shiver."],
      cooling:['"Cooling" sheets let you down',"Cool for five minutes, then they hold your sweat."],
      covers:["Kicking covers off did not help","The layer on your skin was the problem."],
      everything:["Tried just about everything","Every fix cooled the room. This works on the heat."]},
  q6:{_i:"heart",
      dry:["Waking up dry","The fabric's whole job."],
      level:["Cool all night","Dry all night is how you stay level."],
      soft:["Soft on your skin","400 thread-count cotton. Feels like a favourite tee."],
      partner:["Not freezing out your partner","Not a cold sheet. Neutral for the cooler sleeper."],
      laundry:["Fewer 3am sheet changes","Dry sheets stay on the bed."]}
};

/* ============ State from the web address ============ */
var P=new URLSearchParams(location.search);
var SIZE_ALIAS={"split-head king":"King","split head king":"King"};
function normSize(s){ if(!s)return"Queen"; s=decodeURIComponent(s).replace(/\+/g," ").trim(); if(SIZE_ALIAS[s.toLowerCase()])s=SIZE_ALIAS[s.toLowerCase()]; return Object.keys(SHEETS.variants).find(function(k){return k.toLowerCase()===s.toLowerCase();})||"Queen"; }
function clean(s){ return (s||"").replace(/[<>"'&]/g,"").trim().slice(0,40); }
var state={
  result: LOCKED_RESULT || (CONFIG[P.get("result")]?P.get("result"):"furnace"),
  size: normSize(P.get("size")),
  style: (WEAR[(P.get("style")||"").toLowerCase()]?P.get("style").toLowerCase():"mid"),
  name: clean(P.get("name")),
  tier:"set",           /* "sheets" = sheets + gifts. "set" = sheets + sleepwear + gifts, the pick. "wear" = just the sleepwear, no gifts. */
  sheetColor:null, ap:{}
};
var GIFT_CARD=50, INSTALMENTS=4, FREE_SHIP_MIN=150;   /* lusome.com: free shipping on orders over $150 */
var money=function(n){return "$"+n.toFixed(2);}, el=function(id){return document.getElementById(id);};
function hasSheets(){ return state.tier!=="wear"; }
function hasWear(){ return state.tier!=="sheets"; }

/* ============ Render ============ */
function renderCopy(){
  var c=CONFIG[state.result], nm=state.name;
  el('h-lead').textContent = nm ? nm+", your" : "Your";
  el('h-name').textContent = c.rname;
  el('h-one').textContent = c.one;
  el('offerbar').innerHTML = '<span>'+c.offer.replace('[NAME]', nm ? nm+"," : "")+'</span>';   /* one flex item, so the space after her name survives */
  el('why-sheets').innerHTML = "<b>Why you got them:</b> "+c.whySheets;
  el('rev-h').innerHTML = c.revH;
  el('final-h').textContent = c.finalH;
  document.title = (nm ? nm+"'s " : "Your ")+c.rname+" | LUSOME";
  el('revs').innerHTML = c.reviews.map(function(r){ return '<div class="rev"><div class="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div><p>"'+r+'"</p><div class="who">Verified Lusom&eacute; customer</div></div>'; }).join('');
  el('sheet-revs').innerHTML = SHEET_REVIEWS.map(function(r){ return '<div class="rev"><div class="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div><p>"'+r[0]+'"</p><div class="who">'+r[1]+' &middot; verified, lusome.com</div></div>'; }).join('');
  el('sheet-faq').innerHTML = SHEET_FAQ.map(function(f){ return '<details><summary>'+f[0]+'</summary><p>'+f[1]+'</p></details>'; }).join('');
  // "Email me my set": her own mail app, this exact page, no form and no list.
  el('mailme').href = 'mailto:?subject=' + encodeURIComponent('My Lusome sleep set') + '&body=' + encodeURIComponent('Your matched set, sized and priced: ' + location.href);
  el('faq').innerHTML = c.faq.map(function(f,i){ return '<details'+(i===0?' open':'')+'><summary>'+f[0]+'</summary><p>'+f[1].replace('[CODE]','<b>'+CODE+'</b>')+'</p></details>'; }).join('');
  document.querySelectorAll('[data-code]').forEach(function(n){ n.textContent=CODE; });
  // the sleepwear step
  var w=WEAR[state.style];
  el('wear-h').textContent = w.name;
  el('why-wear').innerHTML = "<b>Why you got it:</b> "+w.why;
  el('ticks-wear').innerHTML = w.ticks.map(function(t){return '<li><i></i>'+t+'</li>';}).join('');
  el('img-wear').src = AP[w.keys[0]].img;
  renderMirror();
}
function renderMirror(){
  var rows=[];
  function add(q,v){ var m=SAID[q]&&SAID[q][v]; if(m) rows.push([SAID[q]._i,m[0],m[1]]); }
  add('q1',P.get('q1')); add('q2',P.get('q2'));
  (P.get('q4')||'').split('|').filter(Boolean).slice(0,1).forEach(function(v){add('q4',v);});
  (P.get('q6')||'').split('|').filter(Boolean).slice(0,1).forEach(function(v){add('q6',v);});
  rows=rows.slice(0,3);
  var box=el('mirror');
  if(!rows.length){ box.style.display='none'; return; }
  box.style.display='grid';
  box.innerHTML=rows.map(function(r){return '<li>'+ico(I[r[0]])+'<span><b>'+r[1]+'.</b> '+r[2]+'</span></li>';}).join('');
}

/* ---- the sheets block follows her size and colour ---- */
function renderSheets(){
  var color=state.sheetColor||"White", d=DIMS[state.size];
  el('gal').innerHTML = SHEET_PHOTOS[color].map(function(f,i){ return '<figure><div class="ph"><img src="'+sheetPhoto(color,i,900)+'" alt="Lusomé Temperature-Regulating Sheets in '+color+'" loading="lazy"></div><figcaption>'+PHOTO_CAPS[i]+'</figcaption></figure>'; }).join('');
  el('galnote').textContent = 'Shown in '+color+'. Tap a colour in your set to change it.';
  el('inset-h').textContent = 'What is in your '+state.size+' set';
  el('inset-photo').src = sheetPhoto(color,1,600);
  el('inset-list').innerHTML = [
    [I.flat,   'One flat sheet',                                          d.flat],
    [I.fitted, (d.fittedN===2?'Two twin fitted sheets':'One fitted sheet'), d.fitted+(d.fittedN===2?' each':'')],
    [I.pillow, 'Two '+d.pillowName+' pillowcases',                          d.pillow]
  ].map(function(r){return '<li><span>'+ico(r[0])+'</span><div>'+r[1]+'<small>'+r[2]+'</small></div></li>';}).join('');
}

/* ---- the set ---- */
function initSet(){
  var v=SHEETS.variants[state.size];
  if(!v.some(function(r){return r[0]===state.sheetColor;})) state.sheetColor=v[0][0];
  WEAR[state.style].keys.forEach(function(k){
    if(state.ap[k]) return;
    var vv=AP[k].v, sizes=Object.keys(vv), d=sizes.indexOf("M")>-1?"M":sizes[0];
    state.ap[k]={size:d,color:vv[d][0][0]};
  });
}
function szRow(sizes,active,act,key){return '<div class="sizes">'+sizes.map(function(s){return '<button class="sz'+(s===active?' on':'')+'" data-act="'+act+'" data-key="'+key+'" data-val="'+s+'">'+s+'</button>';}).join('')+'</div>';}
function swRow(colors,active,act,key){return '<div class="swatches">'+colors.map(function(c){return '<button class="sw'+(c===active?' on':'')+'" style="background:'+(HEX[c]||'#ccc')+'" title="'+c+'" aria-label="'+c+'" data-act="'+act+'" data-key="'+key+'" data-val="'+c+'"></button>';}).join('')+'</div><p class="swname">'+active+'</p>';}
function sheetRow(){ return SHEETS.variants[state.size].find(function(r){return r[0]===state.sheetColor;}); }
function wearItems(){
  return WEAR[state.style].keys.map(function(k){ var a=state.ap[k], row=AP[k].v[a.size].find(function(r){return r[0]===a.color;}); return {name:AP[k].name, sub:a.size+" / "+a.color, id:row[1], price:AP[k].price}; });
}
function wearPrice(){ return wearItems().reduce(function(s,x){return s+x.price;},0); }
function items(){
  var it=[];
  if(hasSheets()){ var sr=sheetRow(); it.push({name:"Temperature-Regulating Sheets", sub:state.size+" / "+sr[0], id:sr[1], price:sr[2]}); }
  if(hasWear()) it=it.concat(wearItems());
  return it;
}
function giftList(){
  return '<ul class="gifts"><li>'+ico(I.check)+'<span>Free sleep mask, $48 value</span></li><li>'+ico(I.check)+'<span>$50 gift card by email</span></li></ul>';
}
function renderTiers(){
  var w=WEAR[state.style], sr=sheetRow(), wp=wearPrice();
  var sheetHero='<span><img src="'+sheetPhoto(sr[0],0,800)+'" alt=""></span>';
  var wearTiles=w.keys.map(function(k){return '<span><img src="'+AP[k].img+'&width=600" alt=""></span>';}).join('');
  var a='<button class="tier'+(state.tier==="sheets"?' on':'')+'" data-act="tier" data-val="sheets" aria-pressed="'+(state.tier==="sheets")+'">'
    +'<div class="thd"><span class="k">The sheets</span><span class="radio"></span></div>'
    +'<div class="hero" style="grid-template-columns:1fr">'+sheetHero+'</div>'
    +'<h3>Temperature-Regulating Sheets</h3>'
    +'<p class="desc">'+state.size+' set: flat, fitted, two pillowcases.</p>'
    +'<div class="price">'+money(sr[2])+'</div>'
    +giftList()+'</button>';
  var b='<button class="tier'+(state.tier==="set"?' on':'')+'" data-act="tier" data-val="set" aria-pressed="'+(state.tier==="set")+'">'
    +'<span class="badge">Our pick for you</span>'
    +'<div class="thd"><span class="k">Sheets + sleepwear</span><span class="radio"></span></div>'
    +'<div class="hero" style="grid-template-columns:repeat('+(1+w.keys.length)+',1fr)">'+sheetHero+wearTiles+'</div>'
    +'<h3>Sheets + '+w.name+'</h3>'
    +'<p class="desc">The sheets, plus your sleepwear match on you.</p>'
    +'<div class="price">'+money(sr[2]+wp)+'<small>+ '+money(wp)+' for the sleepwear</small></div>'
    +giftList()+'</button>';
  el('tiers').innerHTML=a+b;
  var alt=el('altlink');
  if(state.tier==="wear"){ alt.className='altlink on'; alt.innerHTML='Just the '+w.name+', full price, no gifts. <button data-act="tier" data-val="set">Add the sheets back</button>'; }
  else { alt.className='altlink'; alt.innerHTML='Just want the sleepwear? <button data-act="tier" data-val="wear">Buy the '+w.name+' on its own, '+money(wp)+'</button>'; }
}
function renderLines(){
  var h='';
  if(hasSheets()){
    var sr=sheetRow();
    h+='<div class="line"><div class="top"><div class="thumb"><img src="'+sheetPhoto(sr[0],1,300)+'" alt=""></div><div><div class="nm">Temperature-Regulating Sheets</div><div class="sub">'+state.size+' / '+sr[0]+'</div></div><div class="pr">'+money(sr[2])+'</div></div>'
      +'<div class="ctl"><div class="lbl">Bed size</div>'+szRow(Object.keys(SHEETS.variants),state.size,'ssize','sheet')+'<div class="lbl">Colour</div>'+swRow(SHEETS.variants[state.size].map(function(r){return r[0];}),state.sheetColor,'scolor','sheet')+'</div></div>';
  }
  if(hasWear()) WEAR[state.style].keys.forEach(function(k){
    var a=state.ap[k], p=AP[k];
    h+='<div class="line"><div class="top"><div class="thumb"><img src="'+p.img+'" alt=""></div><div><div class="nm">'+p.name+'</div><div class="sub">'+a.size+' / '+a.color+' &middot; runs snug, size up</div></div><div class="pr">'+money(p.price)+'</div></div>'
      +'<div class="ctl"><div class="lbl">Size</div>'+szRow(Object.keys(p.v),a.size,'asize',k)+'<div class="lbl">Colour</div>'+swRow(p.v[a.size].map(function(r){return r[0];}),a.color,'acolor',k)+'</div></div>';
  });
  if(hasSheets()){
    h+='<div class="gline">'
      +'<div><div class="thumb"><img src="'+MASK_IMG+'" alt=""></div><div>Collagen Infusion Sleep Mask<small>Free with your sheets, code '+CODE+' at checkout</small></div><div class="pr"><s>'+money(MASK.price)+'</s>FREE</div></div>'
      +'<div><div class="thumb gc">$50</div><div>$50 gift card<small>Emailed after your order</small></div><div class="pr">Included</div></div>'
      +'</div>';
  }
  el('lines').innerHTML=h;
}
function renderTotals(){
  var it=items(), total=it.reduce(function(s,x){return s+x.price;},0), nm=state.name, c=CONFIG[state.result];
  var rows=it.map(function(x){return '<div class="r"><span>'+x.name+'</span><span>'+money(x.price)+'</span></div>';}).join('');
  rows+='<div class="r ship'+(total>=FREE_SHIP_MIN?'':' calc')+'"><span>Shipping</span><span>'+(total>=FREE_SHIP_MIN?'Free':'Calculated at checkout')+'</span></div>';
  rows+='<div class="r tot"><span>'+(hasSheets()?(hasWear()?'Your set':'Your sheets'):'Your sleepwear')+'</span><span class="amt">'+money(total)+'</span></div>';
  rows+='<div class="pay">or '+INSTALMENTS+' payments of <b>'+money(total/INSTALMENTS)+' '+CURRENCY+'</b> with <span class="sz-logo">sezzle</span></div>';
  if(!hasSheets()) rows+='<div class="up"><b>Add the sheets</b> and the free mask and $50 gift card come with them. <button data-act="tier" data-val="set">Switch to the set</button></div>';
  el('totals').innerHTML=rows;
  var link=STORE+"/cart/"+it.map(function(x){return x.id+":1";}).join(",")+(hasSheets()?","+MASK.id+":1?discount="+CODE:"");
  el('buy').href=link;
  el('buy').textContent = hasSheets() ? (hasWear()?'Confirm my set':'Confirm my sheets') : 'Confirm my sleepwear';
  el('fine').innerHTML = hasSheets()
    ? 'Mask added at checkout with code <b>'+CODE+'</b>. Gift card emailed after your order.'
    : 'Full price, no code. Gifts come with the sheets.';
  el('kit-h').textContent = nm ? nm+"'s "+(hasSheets()?(hasWear()?"set":"sheets"):"sleepwear") : (hasSheets()?(hasWear()?"Your set":"Your sheets"):"Your sleepwear");
  var kr = hasSheets() ? SHEET_REVIEWS[1] : [c.reviews[0], 'Verified Lusomé customer'];
  el('kit-review').innerHTML = '<div class="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div><p>"'+kr[0]+'"</p><div class="who">'+kr[1]+(hasSheets()?' &middot; verified, lusome.com':'')+'</div>';
  el('sticky-sum').innerHTML='<b>'+money(total)+'</b> &middot; '+it.length+(it.length===1?' piece':' pieces')+(hasSheets()?' + 2 gifts':'');
}
function renderSet(){ initSet(); renderTiers(); renderLines(); renderTotals(); renderSheets(); }
function renderAll(){ renderCopy(); renderSet(); }

document.addEventListener('click',function(e){
  var b=e.target.closest('[data-act]'); if(!b) return;
  var act=b.dataset.act, key=b.dataset.key, val=b.dataset.val;
  if(act==='tier'){ state.tier=val; }
  else if(act==='ssize'){ state.size=val; state.sheetColor=null; }
  else if(act==='scolor'){ state.sheetColor=val; }
  else if(act==='asize'){ state.ap[key].size=val; var c=AP[key].v[val]; if(!c.some(function(r){return r[0]===state.ap[key].color;})) state.ap[key].color=c[0][0]; }
  else if(act==='acolor'){ state.ap[key].color=val; }
  renderSet();
});
document.querySelectorAll('[data-tabs]').forEach(function(bar){
  bar.addEventListener('click',function(e){
    var t=e.target.closest('.tab'); if(!t) return;
    bar.querySelectorAll('.tab').forEach(function(x){x.classList.toggle('on',x===t);});
    var host=bar.parentElement;
    host.querySelectorAll('.pane').forEach(function(p){p.classList.toggle('on',p.dataset.id===t.dataset.pane);});
  });
});
/* sticky bar: on once she has scrolled past the set, off while the set is on screen */
(function(){
  var set=el('set'), bar=el('sticky');
  function tick(){
    var r=set.getBoundingClientRect(), setOn=r.top<window.innerHeight*0.6 && r.bottom>160;
    bar.classList.toggle('on', window.scrollY>160 && !setOn);
  }
  window.addEventListener('scroll',tick,{passive:true}); window.addEventListener('resize',tick); tick();
})();
renderAll();
